module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('address-name-field', {
    attrs: {
      "error": _vm.$attrs.errors.address.name
    },
    model: {
      value: (_vm.$attrs.address.name),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.address, "name", $$v)
      },
      expression: "$attrs.address.name"
    }
  }), _vm._v(" "), _c('district-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.address.district)),
      expression: "!(formType == 'add' && $attrs.address.district)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.address.district
    },
    model: {
      value: (_vm.$attrs.address.district),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.address, "district", $$v)
      },
      expression: "$attrs.address.district"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb39e81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/address/AddressBlankForm.vue
// module id = 670
// module chunks = 0